import {Component, inject, Input} from '@angular/core';
import {CardComponent, IconComponent, LinkWithoutHrefDirective} from '@icz/angular-essentials';
import {TranslateParser, TranslateService} from '@ngx-translate/core';
import {EntityType} from '|api/commons';
import {Router} from '@angular/router';
import {getSuperclassEntityType} from '|shared';
import {FileCabinetDto} from '|api/document';
import {ApplicationRoute, createAbsoluteRoute, FileCabinetsRoute} from '|ui-essl-core';

@Component({
  selector: 'icz-file-cabinet-association-alert',
  templateUrl: './file-cabinet-association-alert.component.html',
  styleUrl: './file-cabinet-association-alert.component.scss',
  imports: [CardComponent, IconComponent, LinkWithoutHrefDirective],
})
export class FileCabinetAssociationAlertComponent {

  private router = inject(Router);
  private translateParser = inject(TranslateParser);
  private translateService = inject(TranslateService);

  @Input({required: true})
  parentEntityType!: EntityType;
  @Input({required: true})
  fileCabinetInfo: Nullable<FileCabinetDto>;
  @Input({required: true})
  isFileCabinetInfoUnavailable = false;

  get heading() {
    return this.translateParser.interpolate(
      this.translateService.instant('{{entityType}} je vložen do příruční registratury'),
      {
        entityType: this.translateService.instant(`en.entityType.${getSuperclassEntityType(this.parentEntityType)}`),
      }
    )!;
  }

  openFileCabinetTable(fileCabinetInfo: FileCabinetDto) {
    this.router.navigate(
      [createAbsoluteRoute(ApplicationRoute.FILE_CABINETS, FileCabinetsRoute.FILE_CABINETS_TABLE)],
      {queryParams: {fileCabinetId: fileCabinetInfo.id}}
    );
  }

}
